import { ReactElement } from 'react';
import cc from 'classcat';
import { EIconSize } from 'utils/constants/app/ui';
import { createArray } from 'utils/helpers/create-fake-array';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import './index.less';

const CATEGORIES_SKELETON_COUNT = 4;

export const CategoriesHorizontalMobileSkeleton = ({
  namesOnly
}: {
  namesOnly: boolean;
}): ReactElement => {
  return (
    <div
      className={cc([
        'categoriesHorizontalMobile__container',
        {
          categoriesHorizontalMobile__container__namesOnly: namesOnly
        }
      ])}
    >
      {namesOnly ? (
        <div className="categoriesHorizontalMobile__title">
          <Skeleton
            title={{
              style: { height: 14, width: 100, margin: '3px 0' }
            }}
            paragraph={false}
            active
          />
        </div>
      ) : null}
      <div className="categoriesHorizontalMobile__container__wrapper">
        <div className="categoriesHorizontalMobile__container__wrapper__menu">
          {createArray(CATEGORIES_SKELETON_COUNT).map(key => (
            <div
              key={key}
              className="categoriesHorizontalMobile__container__wrapper__menu__item"
            >
              {!namesOnly && <Skeleton.Avatar size={EIconSize._24} active />}
              <div className="categoriesHorizontalMobile__container__wrapper__menu__item__name">
                <Skeleton
                  title={{
                    style: {
                      height: namesOnly ? EIconSize._12 : EIconSize._10,
                      width: 70,
                      margin: namesOnly ? '4px 10px' : '3px 10px'
                    }
                  }}
                  paragraph={false}
                  active
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
